import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import DesktopLayerPopup from '../../common/DesktopLayerPopup';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class Preview extends Component {
  constructor(props) {
    super(props);

    this.iframeRef = null;

    this.isPdf = /pdf/.test(this.props.imageUrl);

    this.state = {
      pdfPageNum: 0,
    };
  }

  componentDidMount() {
    const { imageUrl } = this.props;

    if (!this.isPdf) {
      this.iframeRef.contentDocument.documentElement.innerHTML = `
            <html>
                <body style="margin: 0 50px 50px 50px">
                    <img src=${imageUrl} style="width: 100%" />
                </body>
            </html>
            `;
      this.iframeRef.contentWindow.addEventListener('contextmenu', (e) => {
        e.preventDefault();
      });
    }
  }

  onClose(e) {
    e.preventDefault();
    const { layerKey } = this.props;

    DesktopLayerPopup.hide(layerKey);
  }

  onPdfLoaded({ numPages }) {
    this.setState({ pdfPageNum: numPages });
  }

  renderCloseButton() {
    return (
      <button className="close" onClick={this.onClose.bind(this)}>
        팝업 닫기
      </button>
    );
  }

  renderImage() {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <iframe
          id="reference-room-iframe"
          style={{ width: '100%', height: '100%' }}
          ref={(ref) => (this.iframeRef = ref)}
          frameBorder={0}
        />
      </div>
    );
  }

  renderPdf() {
    const { imageUrl } = this.props;
    const { pdfPageNum } = this.state;

    return (
      <div
        className="preview-pdf-container"
        style={{ overflowY: 'scroll' }}
        onContextMenu={(e) => e.preventDefault()}
      >
        <Document
          file={imageUrl}
          onLoadSuccess={this.onPdfLoaded.bind(this)}
          loading={
            <img
              src="https://s.wink.co.kr/app/parents/images/img_loading.png"
              alt=""
              className="loading"
            />
          }
        >
          {Array.from(new Array(pdfPageNum), (item, inx) => (
            <Page
              key={inx}
              pageNumber={inx + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              loading={false}
            />
          ))}
        </Document>
      </div>
    );
  }

  renderPreview() {
    return this.isPdf ? this.renderPdf() : this.renderImage();
  }

  render() {
    return (
      <div className="layer-wrap large reference-room-preview">
        {this.renderPreview()}
        {this.renderCloseButton()}
      </div>
    );
  }
}

export default Preview;
